import { Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { AuthFormComponent, CustomButton, TextInput } from "../../components";
import { SignUpRequest } from "../../models/request/sign_up_request";
import { sendVerificationEmail, verifyEmail } from "../../services/user.service";
import { signUpUserRequest } from "../../store/slices/user-slice";
import { AppDispatch, RootState } from "../../store/types/store";

const SignUp: React.FC = () => {
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [conf_pwd, setConfPwd] = useState<string>("");
  const [step, setStep] = useState<number>(1);
  const [otp, setOtp] = useState<string>("");

  const dispatch: AppDispatch = useDispatch();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const { signUpResponse, loading } = useSelector(
    (state: RootState) => state.user
  );

  const onFinish = async (values: SignUpRequest) => {
    try {
      const validatedValues = await form.validateFields();
      console.log(
        "All fields are valid. Submitting form with values:",
        validatedValues
      );
      const payload = {
        name: values.name,
        email: values.email,
        password: values.password,
      };
      dispatch(signUpUserRequest(payload));
    } catch (error) {
      console.log("Validation failed:", error);
    }
  };

  useEffect(() => {
    if (signUpResponse) {
      if (signUpResponse.message === "Success") {
        let reqPayload = {
          email: email,
          verificationType: "code",
        };
        sendVerificationEmail(reqPayload)
          .then((response) => {
            setStep(step + 1);
          })
          .catch((error) => {});
      }
    }
  }, [signUpResponse]);

  return step == 1 ? (
    <AuthFormComponent
      header={"Symmatics Core"}
      description={
        "Sign up to access your account and manage Symmatics core functionalities"
      }
      title="Sign Up"
    >
      <Form
        form={form}
        name="normal_login"
        onFinish={onFinish}
        autoComplete="off"
      >
        <TextInput
          className={"mb-3"}
          name="name"
          rules={[{ required: true, message: "Please input your name!" }]}
          placeholder="Enter your name"
          onChange={(e) => setName(e.target.value)}
          value={name}
          label="Name"
        />
        <TextInput
          className={"mb-3"}
          name="email"
          rules={[
            {
              required: true,
              type: "email",
              message: "Please input your email!",
            },
          ]}
          placeholder="Enter your email"
          onChange={(e) => setEmail(e.target.value)}
          value={email}
          label="Email Address"
        />
        <TextInput
          className={"mb-3"}
          name="password"
          password
          rules={[{ required: true, message: "Please input your password!" }]}
          placeholder="Enter your password"
          onChange={(e) => setPassword(e.target.value)}
          value={password}
          label="Password"
        />
        <TextInput
          name="conf_pwd"
          placeholder="Confirm Password"
          value={conf_pwd}
          onChange={(e) => setConfPwd(e.target.value)}
          password
          dependencies={["password"]}
          rules={[
            { required: true, message: "Please confirm your password!" },
            ({ getFieldValue }: any) => ({
              validator(_: unknown, value: string) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error("The two passwords do not match!")
                );
              },
            }),
          ]}
        />
        <CustomButton
          wrapperClass="d-grid"
          btnType={"primary"}
          btnClass="btn-secondary"
          btnText="SignUp"
          loading={loading}
          disabled={loading}
        />
        <div className="mt-3 text-center">
          Already have an account? &nbsp;
          <Link to={"/"} className="text-decoration-none link-muted">
            Sign In
          </Link>
        </div>
      </Form>
    </AuthFormComponent>
  ) : (
    <AuthFormComponent
      header={"Symmatics Core"}
      description={
        "Sign up to access your account and manage Symmatics core functionalities"
      }
      title="Sign Up"
    >
      <Input.OTP
        formatter={(str) => str.toUpperCase()}
        onChange={(text: any) => {
          let otpValue = text;
          setOtp(otpValue);
          if (otpValue.length === 6) {
            let req = {
              email: email,
              verificationHashOrCode: otpValue,
              verificationType: "code",
            };
            verifyEmail(req)
              .then((response) => {
                navigate("/");
              })
              .catch((error) => {});
          }
        }}
        value={otp}
      />
    </AuthFormComponent>
  );
};

export default SignUp;
